import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import "./FloatingCallButton.css";

export default function FloatingCallButton() {
  return (
    <a
      href="tel:0883419000"
      className="fab-call"
      aria-label="Call Ruga's Café"
    >
      <FaPhoneAlt />
    </a>
  );
}